import Image from 'react-bootstrap/Image';

import TituloNegrito from './TituloNegrito';

import aves from '../images/selos/aves.png'
import bovinos from '../images/selos/bovinos.png'
import pescados from '../images/selos/pescados.png'
import pets from '../images/selos/pets.png'
import suinos from '../images/selos/suinos.png'
import caes from '../images/selos/caes.png'
import gatos from '../images/selos/gatos.png'
import equinos from '../images/selos/abea-equinos-portugues.png'

import avesEspanhol from '../images/selos/aves-espanhol.png'
import bovinosEspanhol from '../images/selos/bovinos-espanhol.png'
import pescadosEspanhol from '../images/selos/pescados-espanhol.png'
import suinosEspanhol from '../images/selos/suinos-espanhol.png'
import caesEspanhol from '../images/selos/caes-espanhol.png'
import gatosEspanhol from '../images/selos/gatos-espanhol.png'
import equinosEspanhol from '../images/selos/abea-equinos-espanhol.png'

import avesIngles from '../images/selos/aves-ingles.png'
import bovinosIngles from '../images/selos/bovinos-ingles.png'
import pescadosIngles from '../images/selos/pescados-ingles.png'
import suinosIngles from '../images/selos/suinos-ingles.png'
import caesIngles from '../images/selos/caes-ingles.png'
import gatosIngles from '../images/selos/gatos-ingles.png'
import equinosIngles from '../images/selos/abea-equinos-ingles.png'

import bovinosFrances from '../images/selos/bovinos-frances.png'

import { retornarTexto } from '../helpers/textoHelper'

function Certificacoes({ item, resolucaoMobile, idioma }) {
    const estiloIcone = { height: resolucaoMobile ? '150px' : '250px' }
    
    return (
        <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center justify-content-center' style={{ gap: '20px' }}>
            <TituloNegrito texto={retornarTexto(idioma, 'certificacoesObtidas')} />
            <div className='mb-5 animate__animated animate__fadeIn d-flex flex-wrap align-items-center justify-content-center' style={{ gap: '30px' }}>
                {item['Aves']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={idioma === 'en' || idioma === 'fr' ? avesIngles : idioma === 'es' ? avesEspanhol : aves} alt='logo' fluid /> : <></>}
                {item['Bovinos']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={idioma === 'en' ? bovinosIngles : idioma === 'fr' ? bovinosFrances : idioma === 'es' ? bovinosEspanhol : bovinos} alt='logo' fluid /> : <></>}
                {item['Aqua - Peixes']?.toUpperCase() === 'X' || item['Aqua - Camarões']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={idioma === 'en' || idioma === 'fr' ? pescadosIngles : idioma === 'es' ? pescadosEspanhol : pescados} alt='logo' fluid /> : <></>}
                {item['Suínos']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={idioma === 'en' || idioma === 'fr' ? suinosIngles : idioma === 'es' ? suinosEspanhol : suinos} alt='logo' fluid /> : <></>}
                {item['Cães']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={idioma === 'en' || idioma === 'fr' ? caesIngles : idioma === 'es' ? caesEspanhol : caes} alt='logo' fluid /> : <></>}
                {item['Gatos']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={idioma === 'en' || idioma === 'fr' ? gatosIngles : idioma === 'es' ? gatosEspanhol : gatos} alt='logo' fluid /> : <></>}
                {item['Equinos']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={idioma === 'en' || idioma === 'fr' ? equinosIngles : idioma === 'es' ? equinosEspanhol : equinos} alt='logo' fluid /> : <></>}
            </div>
        </div>
    );
}
export default Certificacoes;
